__turbopack_context__.v({
  "accordion": "BLNNSa_accordion",
  "accordion__content": "BLNNSa_accordion__content",
  "accordion__icon": "BLNNSa_accordion__icon",
  "accordion__section": "BLNNSa_accordion__section",
  "accordion__text": "BLNNSa_accordion__text",
  "accordion__title": "BLNNSa_accordion__title",
  "active": "BLNNSa_active",
  "filerSection": "BLNNSa_filerSection",
  "modal": "BLNNSa_modal",
  "modalBody": "BLNNSa_modalBody",
});
